import {BehaviorSubject, combineLatest, Observable} from 'rxjs';
import {Sort, UrlParameter} from '../../../../../../shared/utils/url.builder';
import {AbstractFindAllService} from './abstractFindAll.service';
import {en} from "@fullcalendar/core/internal-common";

export abstract class CachedtFindAllService<StoredEntity, Entity> {

    readonly findAllService: AbstractFindAllService<StoredEntity, Entity>;
    public entities$: Observable<Entity[]> = new BehaviorSubject<Entity[]>([]);
    public entities: Entity[] = [];
    private additionalEntities: Entity[] = [];

    protected constructor(findAllService: AbstractFindAllService<StoredEntity, Entity>, parameters?: UrlParameter[], sort?: Sort) {
        this.findAllService = findAllService;
        this.findAllService.sort = sort;
        this.findAllService.parameters = parameters;
    }

    forceRefresh() {
        this.entities = [];
        this.findAllService.findAll().then(entities => {
            this.entities = entities;
            this.additionalEntities.forEach(entity => this.entities.push(entity));
            this.additionalEntities = [];
            this.emitChanges();
        });
    }

    findAll() {
        if (this.findAllService.loadingSnapshot === false) {
            if (!this.entities || this.entities.length === 0) {
                this.forceRefresh();
            }
        }
    }
    addToCache(entity: Entity) {
        this.additionalEntities.push(entity);
        this.entities.push(entity);
        this.emitChanges();
    }


    private emitChanges() {
        (this.entities$ as BehaviorSubject<Entity[]>).next(this.entities);
    }

    get loading$(): Observable<boolean> {
        return this.findAllService.loading$;
    }

    get error$(): Observable<boolean> {
        return this.findAllService.error$;
    }
}
